import { render, staticRenderFns } from "./ShowEcoBwDemographic.vue?vue&type=template&id=70266921&scoped=true&"
import script from "./ShowEcoBwDemographic.vue?vue&type=script&lang=js&"
export * from "./ShowEcoBwDemographic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70266921",
  null
  
)

export default component.exports